import { c as _c } from "react/compiler-runtime";
import PriceRangeSlider from "@/components/PriceRangeSlider";
import { Check } from "lucide-react";
export interface FilterOptionData {
  id?: string | number;
  label?: string;
  heading?: string;
  count?: number;
  product_count?: number;
  children?: FilterOptionData[];
}
export interface FilterOptionProps {
  option: string | FilterOptionData;
  type: string;
  checkedValues?: string[];
  selectedValue?: string;
  onChange: (id: string) => void;
  depth?: number;
}
const FilterOption = t0 => {
  const $ = _c(46);
  const {
    option,
    type,
    checkedValues: t1,
    selectedValue,
    onChange,
    depth: t2
  } = t0;
  let t3;
  if ($[0] !== t1) {
    t3 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const checkedValues = t3;
  const depth = t2 === undefined ? 0 : t2;
  const id = String(typeof option === "string" ? option : option.id);
  const label = typeof option === "string" ? option : option.label || option.heading || "Untitled";
  const count = typeof option === "string" ? undefined : option.count ?? option.product_count;
  const hasChildren = typeof option !== "string" && option.children && option.children.length > 0;
  let t4;
  if ($[2] !== checkedValues || $[3] !== id) {
    t4 = checkedValues.includes(id);
    $[2] = checkedValues;
    $[3] = id;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const isChecked = t4;
  const isSelected = selectedValue === id;
  const isActive = type === "checkbox" ? isChecked : isSelected;
  let t5;
  if ($[5] !== depth) {
    t5 = depth > 0 && <div className="absolute top-0 bottom-0 w-[1px] bg-stone-200" style={{
      left: `${(depth - 1) * 24 + 9}px`
    }} />;
    $[5] = depth;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== depth) {
    t6 = depth > 0 && <div className="absolute top-1/2 -translate-y-1/2 h-[1px] bg-stone-200" style={{
      left: `${(depth - 1) * 24 + 9}px`,
      width: "15px"
    }} />;
    $[7] = depth;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const t7 = `flex items-center group cursor-pointer py-1.5 px-1 rounded transition-colors duration-200 hover:bg-stone-50
          ${depth > 0 ? "ml-6" : ""}`;
  let t8;
  if ($[9] !== id || $[10] !== onChange) {
    t8 = () => onChange(id);
    $[9] = id;
    $[10] = onChange;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  const t9 = type === "radio" ? "radio" : "checkbox";
  const t10 = !!isActive;
  let t11;
  if ($[12] !== label || $[13] !== t10 || $[14] !== t9) {
    t11 = <input type={t9} checked={t10} onChange={_temp} className="sr-only" aria-label={label} />;
    $[12] = label;
    $[13] = t10;
    $[14] = t9;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== isActive || $[17] !== type) {
    t12 = type === "checkbox" ? <div className={`w-4 h-4 rounded-[4px] border-2 transition-all duration-300 flex items-center justify-center
                ${isActive ? "bg-[#037a6a] border-[#037a6a] shadow-sm" : "bg-white border-stone-300 group-hover:border-stone-400"}`}>{isActive && <Check size={10} className="text-white stroke-[4px]" />}</div> : <div className={`w-4 h-4 rounded-full border-2 transition-all duration-300 flex items-center justify-center
                ${isActive ? "border-[#037a6a]" : "border-stone-300 group-hover:border-stone-400"}`}>{isActive && <div className="w-2 h-2 rounded-full bg-[#037a6a]" />}</div>;
    $[16] = isActive;
    $[17] = type;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t11 || $[20] !== t12) {
    t13 = <div className="flex-shrink-0 flex items-center justify-center z-10">{t11}{t12}</div>;
    $[19] = t11;
    $[20] = t12;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  const t14 = `ml-3 text-[13px] font-medium transition-colors flex-1 min-w-0 break-words
            ${isActive ? "text-[#037a6a]" : "text-stone-600 group-hover:text-[#037a6a]"}`;
  let t15;
  if ($[22] !== label || $[23] !== t14) {
    t15 = <span className={t14}>{label}</span>;
    $[22] = label;
    $[23] = t14;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== count) {
    t16 = count !== undefined && count !== null && <span className="text-[10px] text-stone-400 font-bold ml-2">{count}</span>;
    $[25] = count;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== t13 || $[28] !== t15 || $[29] !== t16 || $[30] !== t7 || $[31] !== t8) {
    t17 = <div className={t7} onClick={t8}>{t13}{t15}{t16}</div>;
    $[27] = t13;
    $[28] = t15;
    $[29] = t16;
    $[30] = t7;
    $[31] = t8;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== checkedValues || $[34] !== depth || $[35] !== hasChildren || $[36] !== onChange || $[37] !== option || $[38] !== selectedValue || $[39] !== type) {
    t18 = hasChildren && typeof option !== "string" && option.children && <div className="flex flex-col">{option.children.map(child => <FilterOption key={child.id} option={child} type={type} checkedValues={checkedValues} selectedValue={selectedValue} onChange={onChange} depth={depth + 1} />)}</div>;
    $[33] = checkedValues;
    $[34] = depth;
    $[35] = hasChildren;
    $[36] = onChange;
    $[37] = option;
    $[38] = selectedValue;
    $[39] = type;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  let t19;
  if ($[41] !== t17 || $[42] !== t18 || $[43] !== t5 || $[44] !== t6) {
    t19 = <div className="flex flex-col w-full relative">{t5}{t6}{t17}{t18}</div>;
    $[41] = t17;
    $[42] = t18;
    $[43] = t5;
    $[44] = t6;
    $[45] = t19;
  } else {
    t19 = $[45];
  }
  return t19;
};
export interface FilterField {
  label?: string;
  type: "price" | "text" | "checkbox" | "radio";
  min?: number;
  max?: number;
  step?: number;
  options?: (string | FilterOptionData)[];
}
interface FilterSectionProps {
  field: FilterField;
  value: string | string[] | number[] | null | undefined;
  onChange: (value: string | number[]) => void;
}
const FilterSection = t0 => {
  const $ = _c(26);
  const {
    field,
    value,
    onChange
  } = t0;
  if (!field) {
    return null;
  }
  let t1;
  if ($[0] !== field.label || $[1] !== field.type) {
    t1 = field.label && field.type !== "price" && <p className="font-bold text-[10px] uppercase text-stone-400 tracking-wider mb-2">{field.label}</p>;
    $[0] = field.label;
    $[1] = field.type;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== field.max || $[4] !== field.min || $[5] !== field.step || $[6] !== field.type || $[7] !== onChange || $[8] !== value) {
    t2 = field.type === "price" && <PriceRangeSlider min={field.min} max={field.max} step={field.step} value={value as [number, number] || [field.min || 0, field.max || 1000]} onChange={onChange} />;
    $[3] = field.max;
    $[4] = field.min;
    $[5] = field.step;
    $[6] = field.type;
    $[7] = onChange;
    $[8] = value;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== field.type || $[11] !== onChange || $[12] !== value) {
    t3 = field.type === "text" && <input type="text" value={value as string || ""} onChange={e => onChange(e.target.value)} className="w-full p-2.5 bg-stone-50 border rounded-lg outline-none focus:ring-1 focus:ring-v2-primary" placeholder="Search..." aria-label="Search filter" />;
    $[10] = field.type;
    $[11] = onChange;
    $[12] = value;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== field.options || $[15] !== field.type || $[16] !== onChange || $[17] !== value) {
    t4 = (field.type === "checkbox" || field.type === "radio") && field.options?.map(option => {
      const id = String(typeof option === "string" ? option : option.id);
      const checkedValues = Array.isArray(value) ? value.map(String) : [];
      return <FilterOption key={id} option={option} type={field.type} checkedValues={checkedValues} selectedValue={String(value)} onChange={onChange} />;
    });
    $[14] = field.options;
    $[15] = field.type;
    $[16] = onChange;
    $[17] = value;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  let t5;
  if ($[19] !== t2 || $[20] !== t3 || $[21] !== t4) {
    t5 = <div className="space-y-1">{t2}{t3}{t4}</div>;
    $[19] = t2;
    $[20] = t3;
    $[21] = t4;
    $[22] = t5;
  } else {
    t5 = $[22];
  }
  let t6;
  if ($[23] !== t1 || $[24] !== t5) {
    t6 = <div className="py-2">{t1}{t5}</div>;
    $[23] = t1;
    $[24] = t5;
    $[25] = t6;
  } else {
    t6 = $[25];
  }
  return t6;
};
export default FilterSection;
function _temp() {}